import React from "react";
import Card from "./Card";
import PrimaryButton from "../primaryButton";
import { counselingCardImg, pgtCardImg } from "../../assets/images/images";
import "./style.scss";
import { useNavigate } from "react-router-dom";

const PgtCounseling = () => {
  const navigate = useNavigate();
  const NavigateToPGT = () => {
    navigate("/our-technology");
  };
  const NavigateToCounseling = () => {
    navigate("/genetic-counseling");
  };
  return (
    <div className="pgt-counseling">
      <div className="container-fluid">
        <div className="content">
          <div className="cards">
            <Card
              aos="fade-right"
              tag="GATTACA"
              title="PGT"
              cardBtn={
                <>
                  <PrimaryButton
                    primaryBtnText="Explore"
                    className="secondary"
                    handleClick={NavigateToPGT}
                  />
                </>
              }
              cardImg={pgtCardImg}
            />
            <Card
              aos="fade-left"
              tag="GATTACA"
              title="Genetic Counseling"
              cardBtn={
                <>
                  <PrimaryButton
                    primaryBtnText="Explore"
                    className="secondary"
                    handleClick={NavigateToCounseling}
                  />
                </>
              }
              cardImg={counselingCardImg}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PgtCounseling;
